import React from 'react';
import {hot} from 'react-hot-loader/root';
import {renderRoutes} from 'react-router-config';
import {BrowserRouter} from 'react-router-dom';
import universalRoutes from '../../../common/universal-routes';

const Router = ({serverSideProps}) => (
    <BrowserRouter>
        {renderRoutes(universalRoutes.getRoutes(), {serverSideProps})}
    </BrowserRouter>
);

export default hot(Router);
